export interface Attraction {
    name: string;
    requiredHeight?: number;
}
